import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKickstarterComponent } from './simple-icons-kickstarter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKickstarterComponent ],
    exports:      [ SimpleIconsKickstarterComponent ],
    bootstrap:    []
})
export class SimpleIconsKickstarterModule {}
